module.exports = __webpack_public_path__ + "img/logoEn.6fe22b95.png";